export default __webpack_public_path__ + "static/media/img-0263-saudi-arabia-full-face.07fa7631.png";